// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3U6jS","productName":"Table_productName__P8JEF"};